export const initialLetterUser = (firstName = "", lastName) => {
  const firstNameValue = lastName ? firstName : firstName.split(" ")[0];
  const lastNameValue = lastName ? lastName : firstName.split(" ")[1];
  const myStr =
    (firstNameValue || "").charAt(0).toUpperCase() +
    (lastNameValue || "").charAt(0).toUpperCase();

  return myStr;
};
